class SpeakContentData {
  constructor(rate = 1, pitch = 1, volume = 100, bgmVolume = 30, effect, effectValue, bgm, bgmName, label) {
    this.rate = rate;
    this.pitch = pitch;
    this.volume = volume;
    this.bgmVolume = bgmVolume;
    this.effect = effect;
    this.effectValue = effectValue;
    this.bgm = bgm;
    this.bgmName = bgmName;
    this.label = label;
  }
  rate;
  pitch;
  volume;
  bgmVolume;
  effect;
  effectValue;
  bgm;
  bgmName;
  label;
}
class BgmContentData {
  constructor(category, music) {
    this.category = category;
    this.music = music;
  }
  category;
  music;
}

export { BgmContentData, SpeakContentData };
//# sourceMappingURL=data.js.map
